import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

import "firebase/firestore";
import "firebase/auth";

import vuetify from "./plugins/vuetify";
import store from "./store";

import { auth } from "@/firebase";

store.subscribeAction({
  before: (action) => {
    // console.important(`${action.type} was dispatched`);
  },
  after: (action, state) => {
    // console.important(`${action.type} has finished`);
    // console.log(state);
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
  mounted() {
    auth.onAuthStateChanged(currentUser => {
      if (currentUser) {
        this.$store.commit("set_user", {
          loggedIn: true,
          uid: currentUser.uid,
          user: currentUser
        });
      } else {
        this.$store.commit("set_user", {
          loggedIn: false,
          uid: null,
          user: null
        });
        if (this.$route.path === "/") {
          this.$router.push("login");
        }
      }
    });
  }
}).$mount("#app");

// Debugging
console.important = function(msg, ...args) {
  console.info("%c %s %s", "color: lightblue; font-weight: bold;", "ℹ ", msg, ...args);
}

// TODO: Remove this horrible solution I've come up with.
console.get_id_token = function() {
  auth.currentUser.getIdToken().then(token => console.log(token));
}
